import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SourceTypeForm from '../components/SourceTypeForm/SourceTypeForm';
import mapFields from '../../../helpers/mapFields';
import sourceType from '../../../schemas/sourceType';

export default class SourceTypeFormContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    resource: PropTypes.object,
  };

  render() {
    const fields = mapFields(sourceType, this.props.source);

    return <SourceTypeForm {...this.props} fields={fields} />;
  }
}
